import { render, staticRenderFns } from "./v_Admin_Manage_Events.vue?vue&type=template&id=c27982f4&scoped=true&"
import script from "./v_Admin_Manage_Events.vue?vue&type=script&lang=js&"
export * from "./v_Admin_Manage_Events.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c27982f4",
  null
  
)

export default component.exports